import HttpResponse from "../../../../../utils/http/http.response";

export enum BillingsTaxiDriverDetailsResponseContractModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export type BillingsTaxiDriverDetailsResponseDataDriverUser = {
  firstName: string;
  lastName: string;
};

export type BillingsTaxiDriverDetailsResponseDataDriverAddress = {
  displayName: string;
};

export type BillingsTaxiDriverDetailsResponseDataDriver = {
  user: BillingsTaxiDriverDetailsResponseDataDriverUser;
  startingAddress: BillingsTaxiDriverDetailsResponseDataDriverAddress;
};

export type BillingsTaxiDriverDetailsResponseDataFleetPartner = {
  name: string;
};

export type BillingsTaxiDriverDetailsResponseDataTaxiDriverAssociation = {
  driver: BillingsTaxiDriverDetailsResponseDataDriver;
  fleetPartner: BillingsTaxiDriverDetailsResponseDataFleetPartner | null;
};

export type BillingsTaxiDriverDetailsResponseDataContract = {
  model: BillingsTaxiDriverDetailsResponseContractModel;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
  taxiDriverAssociation: BillingsTaxiDriverDetailsResponseDataTaxiDriverAssociation;
  description: string;
};

export type BillingsTaxiDriverDetailsResponseDataBillingNode = {
  id: string;
  nodeId: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate: Date | null;
  checkoutEventId: string | null;
  plannedDate: Date | null;
  orderId: string | null;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export enum BillingsTaxiDriverDetailsResponseDataContributionType {
  BASE_AMOUNT_EXTERNAL_TAXI = "BASE_AMOUNT_EXTERNAL_TAXI",
  BONUS_FAVORABLE_DISTANCE = "BONUS_FAVORABLE_DISTANCE",
  BONUS_OTHER = "BONUS_OTHER",
  PENALTY_WRONG_ROUTE = "PENALTY_WRONG_ROUTE",
  PENALTY_BEING_LATE = "PENALTY_BEING_LATE",
  PENALTY_INCOMPATIBLE_CAR = "PENALTY_INCOMPATIBLE_CAR",
  PENALTY_OTHER = "PENALTY_OTHER",
  CONTRACT_CORRECTION_RATE = "CONTRACT_CORRECTION_RATE",
}

export type BillingsTaxiDriverDetailsResponseDataContributionContractCorrectionBaseAmountExternalTaxi =
  {
    type: BillingsTaxiDriverDetailsResponseDataContributionType.BASE_AMOUNT_EXTERNAL_TAXI;
    comment: string | null;
    distance: number;
    amount: number;
  };

export type BillingsTaxiDriverDetailsResponseDataContributionContractCorrectionRate =
  {
    type: BillingsTaxiDriverDetailsResponseDataContributionType.CONTRACT_CORRECTION_RATE;
    comment: string | null;
    rate: number;
  };

export type BillingsTaxiDriverDetailsResponseDataContributionBonusFavorableDistance =
  {
    type: BillingsTaxiDriverDetailsResponseDataContributionType.BONUS_FAVORABLE_DISTANCE;
    comment: string | null;
    distance: number;
    rate: number;
  };

export type BillingsTaxiDriverDetailsResponseDataContributionBonusOther = {
  type: BillingsTaxiDriverDetailsResponseDataContributionType.BONUS_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiDriverDetailsResponseDataContributionPenaltyWrongRoute =
  {
    type: BillingsTaxiDriverDetailsResponseDataContributionType.PENALTY_WRONG_ROUTE;
    comment: string | null;
    amount: number;
  };

export type BillingsTaxiDriverDetailsResponseDataContributionPenaltyBeingLate =
  {
    type: BillingsTaxiDriverDetailsResponseDataContributionType.PENALTY_BEING_LATE;
    comment: string | null;
    amount: number;
  };

export type BillingsTaxiDriverDetailsResponseDataContributionPenaltyIncompatibleCar =
  {
    type: BillingsTaxiDriverDetailsResponseDataContributionType.PENALTY_INCOMPATIBLE_CAR;
    comment: string | null;
    amount: number;
  };

export type BillingsTaxiDriverDetailsResponseDataContributionPenaltyOther = {
  type: BillingsTaxiDriverDetailsResponseDataContributionType.PENALTY_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiDriverDetailsResponseDataContributionContractCorrection =

    | BillingsTaxiDriverDetailsResponseDataContributionContractCorrectionBaseAmountExternalTaxi
    | BillingsTaxiDriverDetailsResponseDataContributionContractCorrectionRate;

export type BillingsTaxiDriverDetailsResponseDataContributionBonus =
  | BillingsTaxiDriverDetailsResponseDataContributionBonusFavorableDistance
  | BillingsTaxiDriverDetailsResponseDataContributionBonusOther;

export type BillingsTaxiDriverDetailsResponseDataContributionPenalty =
  | BillingsTaxiDriverDetailsResponseDataContributionPenaltyWrongRoute
  | BillingsTaxiDriverDetailsResponseDataContributionPenaltyBeingLate
  | BillingsTaxiDriverDetailsResponseDataContributionPenaltyIncompatibleCar
  | BillingsTaxiDriverDetailsResponseDataContributionPenaltyOther;

export type BillingsTaxiDriverDetailsResponseDataContribution =
  | BillingsTaxiDriverDetailsResponseDataContributionBonus
  | BillingsTaxiDriverDetailsResponseDataContributionPenalty
  | BillingsTaxiDriverDetailsResponseDataContributionContractCorrection;

export type BillingsTaxiDriverDetailsResponseDataCargoOrder = {
  id: string;
  humanId: number;
};

export type BillingsTaxiDriverDetailsResponseDataTransportingOrder = {
  cargoOrder: BillingsTaxiDriverDetailsResponseDataCargoOrder;
};

export type BillingsTaxiDriverDetailsResponseDataSolvedOrder = {
  transportingOrder: BillingsTaxiDriverDetailsResponseDataTransportingOrder;
};

export type BillingsTaxiDriverDetailsResponseDataPlanEntry = {
  humanId: number;
  id: string;
  solvedOrders: BillingsTaxiDriverDetailsResponseDataSolvedOrder[];
};

export type BillingsTaxiDriverDetailsResponseData = {
  contract: BillingsTaxiDriverDetailsResponseDataContract;
  billingNodes: BillingsTaxiDriverDetailsResponseDataBillingNode[];
  billingContributions: BillingsTaxiDriverDetailsResponseDataContribution[];
  allContributionsAmount: number;
  amountForChargeHaltings: number;
  amountForChargeHighways: number;
  distance: number;
  amountForDistance: number;
  planEntry: BillingsTaxiDriverDetailsResponseDataPlanEntry;
  date: Date;
  passengers: string[];
  rateForDistance: number;
  correctedContractModel: BillingsTaxiDriverDetailsResponseContractModel;
  sumOfBonuses: number;
  sumOfPenalties: number;
};

type BillingsTaxiDriverDetailsResponse =
  HttpResponse<BillingsTaxiDriverDetailsResponseData>;

export default BillingsTaxiDriverDetailsResponse;
